import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=7ae717d9&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=ts"
export * from "./SocialLogin.vue?vue&type=script&lang=ts"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=7ae717d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae717d9",
  null
  
)

export default component.exports